export default {
	/**
	 * @param {int} propertyId
	 * @private
	 */
	_applyAutomaticUserSelection(propertyId) {
		const configuration = Object.keys(this.state.configuration.automaticUserSelection)
			.filter(key => parseInt(key, 10) === propertyId)
			.map(key => this.state.configuration.automaticUserSelection[key]);

		if (configuration.length) {
			const userSelection = configuration[0];
			this.state.userSelection = Object.assign({}, this.state.userSelection, userSelection);
		}
	},

	/**
	 * @param {int} facetId
	 * @param {int|null} propertyId
	 * @private
	 */
	_applyUserSelection(facetId, propertyId) {
		// make selection
		if (propertyId === null) {
			if (this.state.userSelection[facetId]) {
				delete this.state.userSelection[facetId];
			}
		} else {
			this.state.userSelection[facetId] = propertyId;
		}
	},

	/**
	 * @param resettingOtherFacetIds
	 * @private
	 */
	_applyResetting(resettingOtherFacetIds) {
		if (resettingOtherFacetIds) {
			resettingOtherFacetIds.forEach((facetIdToBeReset) => {
				if (this.state.userSelection[facetIdToBeReset]) {
					delete this.state.userSelection[facetIdToBeReset];
				}
			});
		}
	},

	/**
	 * @private
	 */
	_applyDefaultUserSelection() {
		this.state.userSelection = Object.assign({}, this.state.configuration.defaultUserSelection);
	},

	getState() {
		return this.state;
	},

	output() {
		this.trigger(this.getState());
	},

	getInitialState() {
		return this.getState();
	}
};
